import type { TranslationKey } from '@change-corgi/core/i18n';

import { getUploadErrorMessages, getUploadErrorReason } from '#src/app/shared/utils/uppyUploader';

import type { UppyFileType } from '../../types';

export type UseUploaderProps = (errorMessage: TranslationKey) => void;

export const handleRestrictionFailed =
	(handleError: UseUploaderProps) =>
	(_file: UppyFileType | undefined, error: Error): void => {
		handleError(getUploadErrorMessages()[getUploadErrorReason(error.message)]);
	};
